import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{attrs:{"column":""}},[_c('label',{staticClass:"caption v-label theme--light"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }